/* newbuid.studio */
(() => {
  const replaceText = (node, find, replace) => node.innerHTML = node.innerHTML.replace(find, replace)

  const updateLoyaltyPoints = () => {
    document.querySelectorAll('.product-info-block .with-icon__beside').forEach(node => {
      const priceEl = node.closest('.product-form')?.querySelector('.price-container .price__current');
      let points = '';
      if (priceEl) {
        points = parseInt(priceEl.textContent.replace('£', '') * 5);
        points = isNaN(points) ? '' : points;
      }
      replaceText(node, '#loyalty_points', points);
    });
  }

  document.addEventListener('DOMContentLoaded', () => updateLoyaltyPoints());
  document.addEventListener('on:quickbuy:after-open', () => updateLoyaltyPoints());
  document.addEventListener('shopify:section:load', () => updateLoyaltyPoints());
  document.addEventListener('shopify:section:deselect', () => updateLoyaltyPoints());
  document.addEventListener('shopify:block:deselect', () => updateLoyaltyPoints());

})();
